import { Image } from 'react-datocms';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { EventCard } from '@carbonify/ui';
import CtaButton from 'components/CtaButton';
import InlineRichText from 'components/RichContent/InlineRichText';
import { ResponsiveImage } from 'services/graphql';

import styles from './EventCardBlock.module.css';

interface EventCardBlockRecord extends CdaStructuredTextRecord {
  image: ResponsiveImage;
  title: string;
  description?: string;
  cta?: string;
  location?: string;
  startDate?: string;
  endDate?: string;
}

export default function EventCardBlock({
  title,
  description,
  image,
  cta,
  startDate,
  endDate,
  location,
}: EventCardBlockRecord) {
  return (
    <EventCard
      // eslint-disable-next-line jsx-a11y/alt-text
      image={<Image data={image.responsiveImage} />}
      className={styles.card}
      title={title}
      startDate={startDate}
      endDate={endDate}
      location={location}
      description={description && <InlineRichText>{description}</InlineRichText>}
      cta={
        <CtaButton
          itemProp="url"
          variant="link"
          className={styles.button}
        >
          {cta}
        </CtaButton>
      }
      locationLabel="Ort:"
      dateLabel="Datum:"
    />
  );
}
